/**
 * Marketing page translations — EN, FR, AR
 * Used by MarketingLayout, HomePage, ServicesPage, PricingPage, ContactPage
 */

const marketingTranslations = {
  // ── Navbar ──
  nav_home: { en: 'Home', fr: 'Accueil', ar: 'الرئيسية' },
  nav_services: { en: 'Services', fr: 'Services', ar: 'الخدمات' },
  nav_pricing: { en: 'Pricing', fr: 'Tarifs', ar: 'الأسعار' },
  nav_contact: { en: 'Contact', fr: 'Contact', ar: 'اتصل بنا' },
  nav_demo: { en: 'Live Demo', fr: 'Démo', ar: 'عرض تجريبي' },

  // ── Footer ──
  footer_tagline: {
    en: 'Digital ordering menus for modern restaurants. No app needed — just scan and order.',
    fr: 'Menus de commande numériques pour les restaurants modernes. Pas d\'app — scannez et commandez.',
    ar: 'قوائم الطلب الرقمية للمطاعم الحديثة. لا حاجة التطبيق-مجرد مسح والنظام.',
  },
  footer_product: { en: 'Product', fr: 'Produit', ar: 'المنتج' },
  footer_company: { en: 'Company', fr: 'Entreprise', ar: 'الشركة' },
  footer_legal: { en: 'Legal', fr: 'Légal', ar: 'قانوني' },
  footer_privacy: { en: 'Privacy Policy', fr: 'Politique de confidentialité', ar: 'سياسة الخصوصية' },
  footer_terms: { en: 'Terms of Service', fr: 'Conditions d\'utilisation', ar: 'شروط الاستخدام' },
  footer_rights: { en: 'All rights reserved.', fr: 'Tous droits réservés.', ar: 'جميع الحقوق محفوظة.' },
  footer_made: { en: 'Made in Morocco 🇲🇦', fr: 'Fabriqué au Maroc 🇲🇦', ar: 'صنع في المغرب 🇲🇦' },

  // ── Hero ──
  hero_badge: { en: 'Built for Moroccan restaurants', fr: 'Conçu pour les restaurants marocains', ar: 'مصمم للمطاعم المغربية' },
  hero_title_1: { en: 'Your menu,', fr: 'Votre menu,', ar: 'قائمتك،' },
  hero_title_2: { en: 'now', fr: 'maintenant', ar: 'الآن' },
  hero_title_3: { en: 'digital', fr: 'numérique', ar: 'رقمية' },
  hero_sub: {
    en: 'Give your customers a beautiful QR menu. They scan, browse, and order via WhatsApp — no app needed, no commission fees.',
    fr: 'Offrez à vos clients un beau menu QR. Ils scannent, consultent et commandent via WhatsApp — sans app, sans commission.',
    ar: 'امنح عملاءك قائمة QR جميلة. يمسحون، يتصفحون، ويطلبون عبر واتساب — بدون تطبيق، بدون عمولات.',
  },
  hero_cta: { en: 'Get Started Free →', fr: 'Commencer gratuitement →', ar: 'ابدأ مجاناً ←' },
  hero_cta_demo: { en: 'See Demo', fr: 'Voir la démo', ar: 'شاهد العرض' },
  hero_trusted: { en: 'Trusted by', fr: 'Fait confiance par', ar: 'موثوق من' },
  hero_restaurants: { en: 'restaurants', fr: 'restaurants', ar: 'مطعم' },

  // ── Features ──
  features_label: { en: 'Features', fr: 'Fonctionnalités', ar: 'المميزات' },
  features_title: { en: 'Everything your restaurant needs', fr: 'Tout ce dont votre restaurant a besoin', ar: 'كل ما يحتاجه مطعمك' },

  feat_qr_title: { en: 'QR Code Menu', fr: 'Menu QR Code', ar: 'قائمة QR Code' },
  feat_qr_desc: {
    en: 'Customers scan, browse, and order — no app download required. Works on any smartphone instantly.',
    fr: 'Les clients scannent, consultent et commandent — sans télécharger d\'app. Fonctionne sur tout smartphone.',
    ar: 'العملاء يمسحون، يتصفحون، ويطلبون — بدون تحميل تطبيق. يعمل على أي هاتف ذكي فوراً.',
  },
  feat_lang_title: { en: 'Multilingual', fr: 'Multilingue', ar: 'متعدد اللغات' },
  feat_lang_desc: {
    en: 'English, French, and Arabic with full RTL support. Reach every customer in their language.',
    fr: 'Anglais, français et arabe avec support RTL complet. Atteignez chaque client dans sa langue.',
    ar: 'الإنجليزية والفرنسية والعربية مع دعم كامل لـ RTL. تواصل مع كل عميل بلغته.',
  },
  feat_wa_title: { en: 'WhatsApp Orders', fr: 'Commandes WhatsApp', ar: 'طلبات واتساب' },
  feat_wa_desc: {
    en: 'Orders go straight to your WhatsApp as a formatted message. No extra apps or tablets needed.',
    fr: 'Les commandes arrivent directement sur votre WhatsApp. Pas d\'apps ou tablettes supplémentaires.',
    ar: 'الطلبات تصل مباشرة إلى واتساب كرسالة منسقة. بدون تطبيقات أو أجهزة إضافية.',
  },
  feat_brand_title: { en: 'Your Brand', fr: 'Votre Marque', ar: 'علامتك التجارية' },
  feat_brand_desc: {
    en: 'Custom logo, colors, and images. Each restaurant gets its own branded page that looks premium.',
    fr: 'Logo, couleurs et images personnalisés. Chaque restaurant a sa propre page premium.',
    ar: 'شعار وألوان وصور مخصصة. كل مطعم يحصل على صفحة خاصة تبدو فاخرة.',
  },
  feat_fast_title: { en: 'Lightning Fast', fr: 'Ultra Rapide', ar: 'سريع جداً' },
  feat_fast_desc: {
    en: 'Static hosting means instant load times. No server lag — your menu loads in under 1 second.',
    fr: 'L\'hébergement statique = chargement instantané. Pas de lag — votre menu charge en moins d\'1 seconde.',
    ar: 'الاستضافة الثابتة تعني تحميل فوري. بدون تأخير — قائمتك تحمل في أقل من ثانية.',
  },
  feat_dark_title: { en: 'Dark Mode', fr: 'Mode Sombre', ar: 'الوضع الداكن' },
  feat_dark_desc: {
    en: 'Automatic dark/light mode based on customer preference. Beautiful in any lighting condition.',
    fr: 'Mode sombre/clair automatique selon la préférence du client. Beau dans toutes conditions.',
    ar: 'وضع داكن/فاتح تلقائي حسب تفضيل العميل. جميل في أي إضاءة.',
  },

  // ── How it works ──
  how_label: { en: 'How it works', fr: 'Comment ça marche', ar: 'كيف يعمل' },
  how_title: { en: 'Live in 3 simple steps', fr: 'En ligne en 3 étapes simples', ar: 'جاهز في 3 خطوات بسيطة' },
  step1_title: { en: 'We Build Your Menu', fr: 'Nous créons votre menu', ar: 'نبني قائمتك' },
  step1_desc: {
    en: 'Send us your menu, logo, and photos. We set up your branded digital menu within 24 hours.',
    fr: 'Envoyez-nous votre menu, logo et photos. Nous créons votre menu numérique en 24h.',
    ar: 'أرسل لنا قائمتك وشعارك وصورك. نجهز قائمتك الرقمية خلال 24 ساعة.',
  },
  step2_title: { en: 'Get Your QR Code', fr: 'Recevez votre QR Code', ar: 'احصل على QR Code' },
  step2_desc: {
    en: 'We generate a custom QR code for your restaurant. Print it on tables, walls, or receipts.',
    fr: 'Nous générons un QR code personnalisé. Imprimez-le sur les tables, murs ou reçus.',
    ar: 'ننشئ لك QR code مخصص لمطعمك. اطبعه على الطاولات أو الجدران أو الفواتير.',
  },
  step3_title: { en: 'Customers Scan & Order', fr: 'Les clients scannent et commandent', ar: 'العملاء يمسحون ويطلبون' },
  step3_desc: {
    en: 'Customers scan the QR code, browse your menu, and send their order directly to your WhatsApp.',
    fr: 'Les clients scannent le QR code, consultent le menu et envoient leur commande sur WhatsApp.',
    ar: 'العملاء يمسحون QR code، يتصفحون قائمتك، ويرسلون طلبهم مباشرة على واتساب.',
  },

  // ── Stats ──
  stat_restaurants: { en: 'Restaurants', fr: 'Restaurants', ar: 'مطعم' },
  stat_commission: { en: 'Commission', fr: 'Commission', ar: 'عمولة' },
  stat_load: { en: 'Load Time', fr: 'Temps de charge', ar: 'وقت التحميل' },
  stat_languages: { en: 'Languages', fr: 'Langues', ar: 'لغات' },

  // ── CTA ──
  cta_title: { en: 'Ready to go digital?', fr: 'Prêt à passer au numérique ?', ar: 'مستعد للتحول الرقمي؟' },
  cta_desc: {
    en: 'Join 50+ restaurants already using Wamenu. Get your digital menu set up in less than 24 hours.',
    fr: 'Rejoignez 50+ restaurants utilisant Wamenu. Obtenez votre menu en moins de 24h.',
    ar: 'انضم لأكثر من 50 مطعم يستخدمون Wamenu. جهز قائمتك الرقمية في أقل من 24 ساعة.',
  },
  cta_btn: { en: 'Get Started — It\'s Free →', fr: 'Commencer — C\'est gratuit →', ar: 'ابدأ الآن — مجاناً ←' },

  // ── Services Page ──
  services_label: { en: 'What We Offer', fr: 'Ce que nous offrons', ar: 'ما نقدمه' },
  services_title: { en: 'Services built for restaurants', fr: 'Services conçus pour les restaurants', ar: 'خدمات مصممة للمطاعم' },
  services_sub: {
    en: 'Everything you need to digitize your menu and start receiving orders — without any technical knowledge.',
    fr: 'Tout ce dont vous avez besoin pour numériser votre menu et recevoir des commandes — sans connaissances techniques.',
    ar: 'كل ما تحتاجه لرقمنة قائمتك وبدء استقبال الطلبات — بدون أي معرفة تقنية.',
  },

  svc_qr_title: { en: 'Digital QR Menu', fr: 'Menu QR Numérique', ar: 'قائمة QR رقمية' },
  svc_qr_desc: {
    en: 'A beautiful, fast, mobile-first menu your customers access by scanning a QR code. Supports images, descriptions, categories, and search.',
    fr: 'Un menu beau, rapide et mobile-first accessible via QR code. Supporte images, descriptions, catégories et recherche.',
    ar: 'قائمة جميلة وسريعة يصل إليها عملاؤك بمسح QR code. تدعم الصور والأوصاف والفئات والبحث.',
  },
  svc_qr_h1: { en: 'Instant load times', fr: 'Chargement instantané', ar: 'تحميل فوري' },
  svc_qr_h2: { en: 'Works on any phone', fr: 'Fonctionne sur tout téléphone', ar: 'يعمل على أي هاتف' },
  svc_qr_h3: { en: 'No app download needed', fr: 'Sans téléchargement d\'app', ar: 'بدون تحميل تطبيق' },

  svc_wa_title: { en: 'WhatsApp Ordering', fr: 'Commande WhatsApp', ar: 'طلب عبر واتساب' },
  svc_wa_desc: {
    en: 'Customers build their cart and send the order directly to your WhatsApp. You receive a clean, formatted message with every item and the total.',
    fr: 'Les clients remplissent leur panier et envoient la commande sur votre WhatsApp. Vous recevez un message formaté avec chaque article et le total.',
    ar: 'العملاء يبنون سلتهم ويرسلون الطلب مباشرة على واتساب. تستقبل رسالة منسقة بكل عنصر والمجموع.',
  },
  svc_wa_h1: { en: 'Pre-filled messages', fr: 'Messages pré-remplis', ar: 'رسائل جاهزة' },
  svc_wa_h2: { en: 'No commission fees', fr: 'Sans commission', ar: 'بدون عمولة' },
  svc_wa_h3: { en: 'Instant notifications', fr: 'Notifications instantanées', ar: 'إشعارات فورية' },

  svc_lang_title: { en: 'Multilingual Support', fr: 'Support Multilingue', ar: 'دعم متعدد اللغات' },
  svc_lang_desc: {
    en: 'Every menu supports English, French, and Arabic with full RTL layout. Your customers choose their language — the menu adapts instantly.',
    fr: 'Chaque menu supporte l\'anglais, le français et l\'arabe avec layout RTL. Vos clients choisissent leur langue — le menu s\'adapte.',
    ar: 'كل قائمة تدعم الإنجليزية والفرنسية والعربية مع تخطيط RTL. عملاؤك يختارون لغتهم — القائمة تتكيف فوراً.',
  },
  svc_lang_h1: { en: '3 languages built-in', fr: '3 langues intégrées', ar: '3 لغات مدمجة' },
  svc_lang_h2: { en: 'Full RTL for Arabic', fr: 'RTL complet pour l\'arabe', ar: 'RTL كامل للعربية' },
  svc_lang_h3: { en: 'Auto-detected preference', fr: 'Préférence auto-détectée', ar: 'تفضيل تلقائي' },

  svc_brand_title: { en: 'Custom Branding', fr: 'Image de Marque', ar: 'علامة تجارية مخصصة' },
  svc_brand_desc: {
    en: 'Your logo, your colors, your vibe. Each restaurant gets a unique branded page that feels like your own — not a generic template.',
    fr: 'Votre logo, vos couleurs, votre style. Chaque restaurant a une page unique à son image — pas un template générique.',
    ar: 'شعارك، ألوانك، أسلوبك. كل مطعم يحصل على صفحة فريدة تعكس هويته — ليس قالب عام.',
  },
  svc_brand_h1: { en: 'Custom logo & images', fr: 'Logo & images personnalisés', ar: 'شعار وصور مخصصة' },
  svc_brand_h2: { en: 'Brand-matching colors', fr: 'Couleurs de marque', ar: 'ألوان متناسقة' },
  svc_brand_h3: { en: 'Unique restaurant URL', fr: 'URL unique du restaurant', ar: 'رابط فريد للمطعم' },

  svc_print_title: { en: 'QR Code Design', fr: 'Design QR Code', ar: 'تصميم QR Code' },
  svc_print_desc: {
    en: 'We design and deliver print-ready QR codes with your branding. Perfect for table tents, wall posters, and receipts.',
    fr: 'Nous concevons et livrons des QR codes prêts à imprimer avec votre marque. Parfait pour les tables, affiches et reçus.',
    ar: 'نصمم ونسلم QR codes جاهزة للطباعة بعلامتك التجارية. مثالية للطاولات والملصقات والفواتير.',
  },
  svc_print_h1: { en: 'Print-ready files', fr: 'Fichiers prêts à imprimer', ar: 'ملفات جاهزة للطباعة' },
  svc_print_h2: { en: 'Branded QR design', fr: 'Design QR de marque', ar: 'تصميم QR بعلامتك' },
  svc_print_h3: { en: 'Multiple sizes included', fr: 'Plusieurs tailles incluses', ar: 'أحجام متعددة مشمولة' },

  svc_update_title: { en: 'Menu Updates', fr: 'Mises à jour du menu', ar: 'تحديثات القائمة' },
  svc_update_desc: {
    en: 'Changed your prices? Added a new dish? We update your digital menu fast — no reprinting, no hassle.',
    fr: 'Prix changés ? Nouveau plat ? Nous mettons à jour votre menu rapidement — sans réimpression.',
    ar: 'غيرت الأسعار؟ أضفت طبق جديد؟ نحدث قائمتك الرقمية بسرعة — بدون إعادة طباعة.',
  },
  svc_update_h1: { en: 'Quick turnaround', fr: 'Délai rapide', ar: 'تنفيذ سريع' },
  svc_update_h2: { en: 'No reprint costs', fr: 'Sans frais de réimpression', ar: 'بدون تكاليف إعادة طباعة' },
  svc_update_h3: { en: 'Seasonal menu support', fr: 'Support menu saisonnier', ar: 'دعم القوائم الموسمية' },

  services_custom_title: { en: 'Need something custom?', fr: 'Besoin de quelque chose sur mesure ?', ar: 'تحتاج شيء مخصص؟' },
  services_custom_desc: {
    en: 'We can tailor any service to your restaurant\'s specific needs. Let\'s talk.',
    fr: 'Nous pouvons adapter tout service aux besoins de votre restaurant. Parlons-en.',
    ar: 'يمكننا تخصيص أي خدمة لاحتياجات مطعمك. دعنا نتحدث.',
  },
  services_custom_cta: { en: 'Contact Us →', fr: 'Contactez-nous →', ar: '← اتصل بنا' },

  // ── Pricing Page ──
  pricing_label: { en: 'Pricing', fr: 'Tarifs', ar: 'الأسعار' },
  pricing_title: { en: 'Simple, honest pricing', fr: 'Tarification simple et honnête', ar: 'أسعار بسيطة وصادقة' },
  pricing_sub: {
    en: 'No hidden fees, no commissions, no surprises. Pick the plan that fits your restaurant.',
    fr: 'Pas de frais cachés, pas de commissions, pas de surprises. Choisissez le plan adapté.',
    ar: 'بدون رسوم مخفية، بدون عمولات، بدون مفاجآت. اختر الخطة المناسبة لمطعمك.',
  },

  plan_main: { en: 'Digital Menu', fr: 'Menu Digital', ar: 'قائمة رقمية' },

  plan_main_desc: {
    en: 'Complete digital menu solution with QR code and WhatsApp ordering.',
    fr: 'Solution complète de menu digital avec QR code et commande WhatsApp.',
    ar: 'حل كامل لقائمة رقمية مع QR وطلب عبر واتساب'
  },

  plan_main_f1: { en: 'QR code menu', fr: 'Menu QR code', ar: 'قائمة QR' },
  plan_main_f2: { en: 'Unlimited items', fr: 'Articles illimités', ar: 'عناصر غير محدودة' },
  plan_main_f3: { en: 'WhatsApp ordering', fr: 'Commande WhatsApp', ar: 'طلب واتساب' },
  plan_main_f4: { en: 'Modern mobile UI', fr: 'Interface mobile moderne', ar: 'واجهة حديثة' },
  plan_main_f5: { en: 'Multi-language (EN/FR/AR)', fr: 'Multi-langues', ar: 'متعدد اللغات' },

  plan_3_months: { en: '3 Months', fr: '3 Mois', ar: '3 أشهر' },
  plan_6_months: { en: '6 Months', fr: '6 Mois', ar: '6 أشهر' },
  plan_12_months: { en: '12 Months', fr: '12 Mois', ar: '12 أشهر' },

  plan_save_10: { en: 'Save 10%', fr: 'Économisez 10%', ar: 'وفر 10%' },
  plan_best_value: { en: 'Best Value', fr: 'Meilleur rapport qualité-prix', ar: 'أفضل قيمة' },

  plan_get_started: { en: 'Get Started', fr: 'Commencer', ar: 'ابدأ الآن' },

  pricing_zero_title: { en: 'Zero commission — always', fr: 'Zéro commission — toujours', ar: 'بدون عمولة — دائماً' },
  pricing_zero_desc: {
    en: 'Unlike delivery platforms that take 15-30% of every order, Wamenu charges a flat monthly fee. Whether you get 10 or 10,000 orders — you keep every dirham.',
    fr: 'Contrairement aux plateformes de livraison qui prennent 15-30% par commande, Wamenu a un tarif mensuel fixe. 10 ou 10 000 commandes — vous gardez chaque dirham.',
    ar: 'على عكس منصات التوصيل التي تأخذ 15-30% من كل طلب، Wamenu يقدم رسوم شهرية ثابتة. سواء 10 أو 10,000 طلب — كل درهم لك.',
  },

  faq_title: { en: 'Frequently asked questions', fr: 'Questions fréquentes', ar: 'الأسئلة الشائعة' },
  faq_1_q: { en: 'How fast can I get set up?', fr: 'En combien de temps suis-je en ligne ?', ar: 'كم يستغرق الإعداد؟' },
  faq_1_a: {
    en: 'Most restaurants are live within 24 hours. Just send us your menu and logo, and we handle everything.',
    fr: 'La plupart des restaurants sont en ligne en 24h. Envoyez-nous votre menu et logo, on s\'occupe du reste.',
    ar: 'معظم المطاعم تكون جاهزة خلال 24 ساعة. فقط أرسل لنا قائمتك وشعارك ونتكفل بكل شيء.',
  },
  faq_2_q: { en: 'Do you take commissions on orders?', fr: 'Prenez-vous des commissions ?', ar: 'هل تأخذون عمولة على الطلبات؟' },
  faq_2_a: {
    en: 'Never. We charge a flat monthly fee — 0% commission on all orders. Your revenue stays yours.',
    fr: 'Jamais. Nous avons un tarif mensuel fixe — 0% de commission. Vos revenus restent les vôtres.',
    ar: 'أبداً. نحن نقدم رسوم شهرية ثابتة — 0% عمولة على كل الطلبات. إيراداتك لك.',
  },
  faq_3_q: { en: 'Can I change my plan later?', fr: 'Puis-je changer de plan plus tard ?', ar: 'هل يمكنني تغيير خطتي لاحقاً؟' },
  faq_3_a: {
    en: 'Absolutely. You can upgrade, downgrade, or cancel anytime. No long-term contracts.',
    fr: 'Absolument. Vous pouvez changer ou annuler à tout moment. Sans engagement.',
    ar: 'بالتأكيد. يمكنك الترقية أو التخفيض أو الإلغاء في أي وقت. بدون عقود طويلة.',
  },
  faq_4_q: { en: 'What currency are the prices in?', fr: 'En quelle devise sont les prix ?', ar: 'بأي عملة الأسعار؟' },
  faq_4_a: {
    en: 'All prices are in Moroccan Dirhams (MAD). We may offer USD/EUR pricing in the future.',
    fr: 'Tous les prix sont en Dirhams marocains (MAD). Nous proposerons peut-être USD/EUR à l\'avenir.',
    ar: 'جميع الأسعار بالدرهم المغربي (MAD). قد نقدم أسعار بالدولار/اليورو مستقبلاً.',
  },

  // ── Contact Page ──
  contact_label: { en: 'Get in Touch', fr: 'Contactez-nous', ar: 'تواصل معنا' },
  contact_title: { en: "Let's digitize your menu", fr: 'Numérisons votre menu', ar: 'لنرقمن قائمتك' },
  contact_sub: {
    en: 'Fill the form or message us on WhatsApp. We usually respond within 1 hour.',
    fr: 'Remplissez le formulaire ou écrivez-nous sur WhatsApp. Réponse en 1h généralement.',
    ar: 'املأ النموذج أو راسلنا على واتساب. نرد عادةً خلال ساعة.',
  },
  contact_name: { en: 'Your Name', fr: 'Votre nom', ar: 'اسمك' },
  contact_name_ph: { en: 'Ahmed Benali', fr: 'Ahmed Benali', ar: 'أحمد بنعلي' },
  contact_restaurant: { en: 'Restaurant Name', fr: 'Nom du restaurant', ar: 'اسم المطعم' },
  contact_restaurant_ph: { en: 'Café Royal', fr: 'Café Royal', ar: 'كافيه رويال' },
  contact_phone: { en: 'Phone / WhatsApp', fr: 'Téléphone / WhatsApp', ar: 'هاتف / واتساب' },
  contact_phone_ph: { en: '+212 6XX XXX XXX', fr: '+212 6XX XXX XXX', ar: '+212 6XX XXX XXX' },
  contact_message: { en: 'Message (optional)', fr: 'Message (optionnel)', ar: 'رسالة (اختياري)' },
  contact_message_ph: {
    en: 'Tell us about your restaurant, how many items on your menu, or any questions...',
    fr: 'Parlez-nous de votre restaurant, combien d\'articles dans votre menu, ou toute question...',
    ar: 'أخبرنا عن مطعمك، كم عنصر في قائمتك، أو أي أسئلة...',
  },
  contact_send_wa: { en: 'Send via WhatsApp', fr: 'Envoyer via WhatsApp', ar: 'أرسل عبر واتساب' },
  contact_or: { en: 'or', fr: 'ou', ar: 'أو' },
  contact_send_email: { en: 'Send via Email', fr: 'Envoyer par email', ar: 'أرسل عبر البريد' },
  contact_success_title: { en: 'Message sent!', fr: 'Message envoyé !', ar: 'تم إرسال الرسالة!' },
  contact_success_desc: {
    en: "We'll get back to you shortly on WhatsApp. In the meantime, check out our demo menu.",
    fr: 'Nous vous répondrons rapidement sur WhatsApp. En attendant, consultez notre menu démo.',
    ar: 'سنرد عليك قريباً على واتساب. في هذه الأثناء، تفقد قائمتنا التجريبية.',
  },
  contact_send_another: { en: 'Send another message', fr: 'Envoyer un autre message', ar: 'إرسال رسالة أخرى' },
  contact_wa_label: { en: 'WhatsApp', fr: 'WhatsApp', ar: 'واتساب' },
  contact_wa_desc: { en: "Message us anytime — we're fastest on WhatsApp.", fr: 'Écrivez-nous à tout moment — WhatsApp est le plus rapide.', ar: 'راسلنا في أي وقت — نحن أسرع على واتساب.' },
  contact_email_label: { en: 'Email', fr: 'Email', ar: 'البريد الإلكتروني' },
  contact_email_desc: { en: 'For detailed inquiries or partnerships.', fr: 'Pour demandes détaillées ou partenariats.', ar: 'للاستفسارات المفصلة أو الشراكات.' },
  contact_location_label: { en: 'Location', fr: 'Localisation', ar: 'الموقع' },
  contact_location_desc: { en: 'Based in Morocco. Serving restaurants nationwide.', fr: 'Basé au Maroc. Service national.', ar: 'مقرنا في المغرب. نخدم المطاعم في كل أنحاء البلاد.' },
  contact_response_label: { en: 'Response Time', fr: 'Temps de réponse', ar: 'وقت الرد' },
  contact_response_desc: { en: 'Usually within 1 hour during business hours (9 AM – 9 PM GMT+1).', fr: 'Généralement en 1h pendant les heures de bureau (9h – 21h GMT+1).', ar: 'عادةً خلال ساعة واحدة أثناء ساعات العمل (9 ص – 9 م GMT+1).' },
  contact_trusted_by: { en: 'Trusted by', fr: 'Fait confiance par', ar: 'موثوق من' },
  contact_across: { en: 'across Morocco', fr: 'à travers le Maroc', ar: 'عبر المغرب' },
};

/**
 * Hook-style helper: pass language code, get translator
 * Usage: const mt = getMarketingT('fr');  mt('hero_title')
 */
export function getMarketingT(lang = 'en') {
  return (key) => {
    const entry = marketingTranslations[key];
    if (!entry) return key;
    return entry[lang] || entry['en'] || key;
  };
}

export default marketingTranslations;